var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg066Printer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 8H18V3C18 2.44772 17.5523 2 17 2H7C6.44772 2 6 2.44772 6 3V8H3C2.44772 8 2 8.44772 2 9V17C2 17.5523 2.44772 18 3 18H6V21C6 21.5523 6.44772 22 7 22H17C17.5523 22 18 21.5523 18 21V18H21C21.5523 18 22 17.5523 22 17V9C22 8.44772 21.5523 8 21 8ZM8 4H16V8H8V4ZM16 20H8V15H16V20ZM20 16H18V14C18 13.4477 17.5523 13 17 13H7C6.44772 13 6 13.4477 6 14V16H4V10H20V16Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg066Printer);
export default __webpack_public_path__ + "static/media/066-printer.e309d1f073215b0bea0eb25792421d60.svg";
export { ForwardRef as ReactComponent };